import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=d316f2ae&scoped=true"
import script from "./VideoWrapper.vue?vue&type=script&lang=js"
export * from "./VideoWrapper.vue?vue&type=script&lang=js"
import style0 from "./VideoWrapper.vue?vue&type=style&index=0&id=d316f2ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d316f2ae",
  null
  
)

export default component.exports